import { render, staticRenderFns } from "./SampleAssignment.vue?vue&type=template&id=51746550&"
import script from "./SampleAssignment.vue?vue&type=script&lang=js&"
export * from "./SampleAssignment.vue?vue&type=script&lang=js&"
import style0 from "./SampleAssignment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports